.credits-left {
  transition: all 0.3s ease-in-out;
  color: #0e0934;
}

.credits-left:hover {
  background-color: #0e0934;
  color: white;
}
